module.exports = __webpack_public_path__ + "img/user.5c0015ed.png";